export default __webpack_public_path__ + "static/media/heroImage.1c3f5b7b.jpeg";